import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { APP_TEXTS } from '../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';
import { unitTransform, unitLabel } from '@services/helper.service';
import { defaultUnits } from '@config';
import Input from '@components/Input';

export default class WallDimensions extends Component {

  static propTypes = {
    onUpdate: PropTypes.func.isRequired,
    options: PropTypes.shape()
  };

  static defaultProps = {
    options: {}
  };

  render() {
    return (
      <div className="calculation">
        <section className="list-type">
          <h4>{APP_TEXTS.WALL_WIDTH.Content}</h4>
          <Tooltip content={APP_TOOLTIPS.TOOLTIP_DISTANCE_BETWEEN_WALLS.Content}>
            <Input
              id="W"
              prefix="W:"
              postfix={unitLabel(this.props.distanceUnit)}
              type="number"
              minValue={0}
              value={unitTransform(+this.props.options.ground.walls.depth).from(defaultUnits.DISTANCE).to(this.props.distanceUnit)}
              onUpdate={this.setW}
            />
          </Tooltip>
        </section>
      </div>
    );
  }

  setW = (value) => {
    this.onUpdate({
      walls: {
        depth: unitTransform(+value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
      }
    });
  };

  onUpdate(options) {
    this.props.onUpdate(options);
  }

}




// WEBPACK FOOTER //
// ./src/views/Dimension/components/WallDimensions/index.js